/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export enum RiskCardType {
  Text = 'Text',
  Number = 'Number',
  AddOrRemoveItems = 'AddOrRemoveItems',
  AddOrRemoveItemsWithColor = 'AddOrRemoveItemsWithColor',
  Calculation = 'Calculation',
}

export const RiskCardTypes = [
  RiskCardType.Text,
  RiskCardType.Number,
  RiskCardType.AddOrRemoveItems,
  RiskCardType.AddOrRemoveItemsWithColor,
  RiskCardType.Calculation,
];

export enum RiskCardComponentType {
  Text = 'RiskCardText',
  Number = 'RiskCardNumber',
  AddOrRemoveItems = 'RiskAddOrRemoveItems',
  AddOrRemoveItemsWithColor = 'RiskAddOrRemoveItems',
  Calculation = 'RiskCalculationBuilder',
}

export enum RiskAddOrRemoveItemsType {
  FactorOptions = 'factorOptions',
  VectorThresholds = 'vectorThresholds',
  ScoreThresholds = 'scoreThresholds',
}
